export class CmpCreatedByUserObject {
    id: number | string = 0;
    firstName = '';
    lastName = '';
    email: string | null = null;
}
export class CmpUserAdminProfileObject {
    active = true;
    staffCampName = '';
    userActiveUntil = false;
    userActiveUntilDate: string | null = null;
    salesforceUserId = '';
    gender = '';
    camperUserId: number | null =  null;
}

export class CmpUserConsumerProfileObject {
    gender = '';
    dob: string | null = null;
    adult = false;
    grade: string | null = null;
    imageUrl: string | null = null;
    salesforceAccountId = '';
    salesforceContactId = '';
    visibility = 1;
    visibilityExplanation = '';
    createdBy = new CmpCreatedByUserObject;
    updatedBy = new CmpCreatedByUserObject;
    graduationYear: string | null = null;
    nickName: string | null = null;
    age?: number | null = null;
    defaultConsumerType = '';
}

export enum CmpUserTypes {
    admin = 'admin',
    consumer = 'consumer'
}

export class CmpUserObject {
    id = 0;
    firstName = '';
    lastName = '';
    familyId = 0;
    email: string | null = null;
    emailVerifiedAt: string | null = null;
    type: CmpUserTypes = CmpUserTypes.admin;
    name: string | null = '';
    password = '12345';
    confirmPassword = '12345';
    isDeletable = true;
    isDeleted = false;
    userAdminProfile: {[index: string]: CmpUserAdminProfileObject} = {'0': new CmpUserAdminProfileObject};
    userConsumerProfile:  {[index: string]: CmpUserConsumerProfileObject} = {'0': new CmpUserConsumerProfileObject};
    relationship: string | null = null;
    active = true;
    roles = {};
    createdAt = {
        date: '',
        timezone: ''
    };
    updatedAt = {
        date: '',
        timezone: ''
    };
    deletedAt = '';
}
export class CmpUserPhoneObject {
    id = 0;
    optedIn = true;
    phone = '';
    phoneTypeId = 0;
    primary = true;
    userId = 0;
    extension = '';
}
export class CmpUserEmailObject {
    id = 0;
    optedIn = true;
    email = '';
    primary = true;
    userId = 0;
}

export class CmpBasicUserObject {
    userId = 0;
    familyId = 0;
    name = '';
    adult = true;
    dob: string | null = '';
    gender = '';
    firstName = '';
    lastName = '';
}

export class CmpCommunicationSettingObject {
    emailOptIn = '';
    archiveEmail = '';
    promotionalEmailOptInExplanation = '';
    messageWaitTime = 0;
    sendFrom: Array<CmpCommunicationSettingEmailOptionsObject> =  [new CmpCommunicationSettingEmailOptionsObject];
    replyTo: Array<CmpCommunicationSettingEmailOptionsObject> =  [new CmpCommunicationSettingEmailOptionsObject];
}


export class CmpCommunicationSmsSettingObject {
    smsOptInPrompt = '';
    smsOptInExplanation = '';
    smsOptInExplanationDisplay = 'tooltip';
    smsWelcomeMessage = '';
    smsTermsAndConditionsUrl = '';
}

export class CmpCommunicationSettingEmailOptionsObject {
    name = '';
    email = '';
}

export class CmpSmsOptInCopy {
    prompt = '';
    explanation = '';
    explanationHtml = '';
    inline = false;
}
